import categoryViewService from "../categoryViewService";
import constants from "../../constants";
import utils from "../utils";
import h from "../h";

export default {
  isAssignerOrDelegator(tkTask, userDeptRole) {
    return (
      userDeptRole.id === tkTask.assignerUserDeptRoleId ||
      userDeptRole.id === tkTask.delegatorId
    );
  },

  isAsReceiverRole(tkTask, userDeptRole) {
    return userDeptRole.id === tkTask.receiverUserDeptRoleId;
  },

  isViewChildTask(tkTask, userDeptRole) {
    return userDeptRole.id === tkTask.receiverUserDeptRoleId || userDeptRole.id === tkTask.assignerUserDeptRoleId;
  },

  isAsAssignerRole(tkTask, userDeptRole, currentDelegators) {
    return (
      this.isAssignerOrDelegator(tkTask, userDeptRole) ||
      h.exists(currentDelegators, delegator =>
        this.isAssignerOrDelegator(tkTask, delegator)
      )
    );
  },

  loadTaskPriorities(options) {
    return categoryViewService
      .findAll(
        { groupCode: constants.CATEGORY_GROUP_CODE.TASK_PRIORITY },
        { sort: "order,asc", page: 0, size: 1000 }
      )
      .then(response =>
        utils.filterCategoryData(response.data, options.status)
      );
  },

  getActionLogActionNameLabel(actionName) {
    switch (actionName) {
      case constants.ACTION_LOG_ACTION_NAME.TK_TASK.CHANGE_DEADLINE:
        return "Gia hạn";
      default:
        return actionName;
    }
  },

  getTaskStatusLabel(status) {
    switch (status) {
      case constants.TASK_STATUS.CHO_PHE_DUYET_DK:
        return "Chờ phê duyệt";
      case constants.TASK_STATUS.DANG_THUC_HIEN:
        return "Chưa hoàn thành";
      case constants.TASK_STATUS.HUY_PHE_DUYET_DK:
        return "Hủy phê duyệt";
      case constants.TASK_STATUS.HOAN_THANH:
        return "Hoàn thành";
      case constants.TASK_STATUS.KET_THUC:
        return "Kết thúc";
      case constants.TASK_STATUS.HUY:
        return "Hủy";
      case constants.TASK_STATUS.TAM_DUNG:
        return "Tạm dừng";
      default:
        return "";
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/task/taskUtils.js